import React, {useState} from 'react'
import {sharedStyles} from '../../../../style/shared_styles'
import {CustomModal, TitleText} from '../../../common'
import {i18n} from '../../../../i18n'
import {Button} from 'antd'
import {ButtonStyle} from '../../../../style/button'
import styles from '../../styles/TherapyTab.style'
import EditTherapy from '../../actions/EditTherapy'
import {useStores} from "../../../../store"
import {TherapyStatus} from "../../../../utils/enums"
import MedicationOrderModal from "../subcomponents/MedicationOrderModal"
import MedicationOrderButton from "../subcomponents/MedicationOrderButton";

/**
 * Component containing the therapy plan header including order and new therapy actions.
 */
const TherapyPlanHeader: React.FC<MedicationHeaderProps> = (props: MedicationHeaderProps) => {
    const [editModalVisible, setEditModalVisible] = useState(false)
    const [orderSummaryModalVisible, setOrderSummaryModalVisible] = useState(false)

    const {therapyStore} = useStores()
    const status = therapyStore.therapyComplete?.generalInfo.status


    const handleOrderSummaryClick = () => {
        setOrderSummaryModalVisible(true)
    }

    const handleOrderSummaryModalClose = () => {
        setOrderSummaryModalVisible(false)
    }

    const showOrderSummaryButton = status === TherapyStatus.RELEASED || status === TherapyStatus.CLOSED

    return (
        <div>
            <div style={sharedStyles.inlineContainer}>
                <TitleText text={i18n.t('therapyTab.header.title')}/>
                <div>
                    {showOrderSummaryButton && (
                        <MedicationOrderButton
                            onClick={handleOrderSummaryClick}
                        />
                    )}

                    {!props.hasOperationsErrors && (
                        <Button type={'default'} shape={'round'} style={ButtonStyle.primary}
                                onClick={() => setEditModalVisible(true)}>
                            {i18n.t('therapyTab.actions.newTherapy')}
                        </Button>
                    )}
                </div>
            </div>
            {props.showMessage && (
                <div style={styles.messageContainer}>
                    <p style={styles.messageTitle}>{i18n.t('therapyTab.message.title')}</p>
                    <p>{i18n.t('therapyTab.message.content')}</p>
                </div>
            )}

            {/* Edit Therapy Modal */}
            <CustomModal title={i18n.t('therapy.newTitle')} open={editModalVisible} maxWidth={'350px'}>
                <EditTherapy onCloseModal={() => setEditModalVisible(false)}/>
            </CustomModal>

            {/* Order Summary Modal */}
            <MedicationOrderModal
                visible={orderSummaryModalVisible}
                onClose={handleOrderSummaryModalClose}
            />
        </div>
    )
}

type MedicationHeaderProps = {
    showMessage?: boolean
    hasOperationsErrors: boolean | undefined | null
}

export default TherapyPlanHeader